import type { DashboardSection } from '@library/api-customer-engagement-experience'

type HeroSection = Extract<DashboardSection, { type: 'unsubscribed_hero' | 'unsubscribed_hero_v2' }>

export const selectHeroSection = (
  sections: DashboardSection[],
  isV2Enabled: boolean,
): HeroSection | null => {
  const legacyHero = sections.find(
    (section): section is Extract<DashboardSection, { type: 'unsubscribed_hero' }> =>
      section.type === 'unsubscribed_hero',
  )
  const newHero = sections.find(
    (section): section is Extract<DashboardSection, { type: 'unsubscribed_hero_v2' }> =>
      section.type === 'unsubscribed_hero_v2',
  )

  if (legacyHero && newHero) {
    return isV2Enabled ? newHero : legacyHero
  }

  return newHero ?? legacyHero ?? null
}
